// src/components/BreakModal.js
import React from 'react';
import './BreakModal.css'; // We'll create this CSS file next

function BreakModal({ onClose, imageSrc }) {
  // Default image if none provided - user should replace this in App.js
  const displayImage = imageSrc || "/break-placeholder.webp"; // Example placeholder

  return (
    // Overlay container, click anywhere on the dark overlay to close
    <div className="break-modal-overlay" onClick={onClose}>
      {/* Content container prevents click closing if clicking the image itself */}
      <div className="break-modal-content" onClick={(e) => e.stopPropagation()}>
        <img src={displayImage} alt="Taking a break!" className="break-modal-image" />
        <button className="close-break-modal-button" onClick={onClose} title="Resume Game">
          &times; {/* HTML entity for a multiplication sign (X) */}
        </button>
      </div>
    </div>
  );
}

export default BreakModal;
